import React from 'react';
import '../../components/DBOSHomepage.css';
import '../SmartWeb.css';
import './Legal.css';

const DPA = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="container">
          <a href="/" className="logo">
            <span className="logo-text shimmering">DBOS.world</span>
          </a>
        </div>
      </header>
      <main className="legal-content">
        <div className="container">
          <h1>Data Processing Agreement</h1>
          <p className="version-info">V1.0 | 03/03/2026</p>
          
          <section className="legal-section">
            <p>This Data Processing Agreement forms part of the DBOS Service Agreement and governs the processing of Personal Data in accordance with the General Data Protection Regulation (GDPR).</p>
          </section>

          <section className="legal-section">
            <h2>1. Parties</h2>
            <p><strong>Processor:</strong> DBOS (operating under Smart Trades Training, CRO No. 778363, Ireland)</p>
            <p><strong>Controller:</strong> The Client</p>
          </section>

          <section className="legal-section">
            <h2>2. Subject Matter & Duration</h2>
            <p>This DPA applies to all Personal Data processed by the Processor on behalf of the Controller in connection with the DBOS Service Agreement.</p>
          </section>

          <section className="legal-section">
            <h2>3. Nature and Purpose of Processing</h2>
            <p>Processing may include:</p>
            <ul>
              <li>Storage of client data</li>
              <li>Hosting services</li>
              <li>Cloud infrastructure coordination</li>
              <li>Technical support</li>
              <li>Automation workflows</li>
            </ul>
            <p><strong>Purpose:</strong> To provide digital infrastructure, automation, consulting, and related services within the DBOS framework.</p>
          </section>

          <section className="legal-section">
            <h2>4. Categories of Data</h2>
            <p>Depending on the Client's business, data may include: Contact information, Customer data, Employee data, Business communication data, Technical usage data.</p>
          </section>

          <section className="legal-section">
            <h2>5. Obligations of the Processor</h2>
            <p>The Processor shall:</p>
            <ul>
              <li>Process Personal Data only on documented instructions from the Controller</li>
              <li>Ensure confidentiality of personnel involved in processing</li>
              <li>Implement appropriate technical and organizational measures</li>
              <li>Assist the Controller in responding to Data Subject requests</li>
              <li>Notify the Controller of any Personal Data breach</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Subprocessors</h2>
            <p>The Controller authorizes the Processor to engage Subprocessors as necessary for service delivery:</p>
            <ul>
              <li>Cloud hosting providers (Firebase, Google Cloud)</li>
              <li>Payment processors (Stripe)</li>
              <li>Communication platforms</li>
            </ul>
            <p>All Subprocessors are bound by GDPR-compliant agreements.</p>
          </section>

          <section className="legal-section">
            <h2>7. International Data Transfers</h2>
            <p>Where data is transferred outside the European Economic Area (EEA), the Processor ensures appropriate safeguards such as Standard Contractual Clauses (SCCs) are applied.</p>
          </section>

          <section className="legal-section">
            <h2>8. Data Subject Rights</h2>
            <p>The Processor shall assist the Controller in fulfilling obligations relating to: Right of access, Rectification, Erasure, Restriction of processing, Data portability, and Objection.</p>
          </section>

          <div className="legal-footer">
            <p><a href="/legal/terms">Terms</a> | <a href="/legal/privacy">Privacy</a> | <a href="/legal/cookies">Cookies</a></p>
            <a href="/" className="btn-back">← Back to Home</a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DPA;
